import { UserMenuSchema } from './UserPermissionHelper';
import { AppMenu, AppUserMenu } from '@/api/models';

export interface ITourBagSettings {
  clubHistory: boolean;
  clubDeleted: boolean;
}

interface ITourBagItem {
  appMenuId: number;
  name: string;
  uiName: string;
  parentAppMenuId: number;
}

type TourReportsMap = Record<string, ITourBagItem>;

interface IGetTourBagSettingsProps {
  appMenus: AppMenu[];
  userMenus: AppUserMenu[];
  userMenuSchema: UserMenuSchema;
}

export const getTourBagSettings = ({ appMenus, userMenus, userMenuSchema }: IGetTourBagSettingsProps): ITourBagSettings => {
  const tourMenuId = userMenuSchema.TourBag.appMenuId;

  const tourReportsMap: TourReportsMap = appMenus
    .filter((menu) => menu.parentAppMenuId === tourMenuId)
    .reduce((acc, menu) => {
      acc[menu.name] = {
        appMenuId: menu.appMenuId,
        name: menu.name,
        uiName: menu.uiName,
        parentAppMenuId: menu.parentAppMenuId!,
      };
      return acc;
    }, {} as TourReportsMap);

  const hasAccess = (reportName: string) => {
    const report = tourReportsMap[reportName];
    return report ? userMenus.some((um) => um.appMenuId === report.appMenuId) : false;
  };

  const tourReportsSettings: ITourBagSettings = {
    clubDeleted: hasAccess('ClubDeleted'),
    clubHistory: hasAccess('ClubHistory'),
  };

  return tourReportsSettings;
};
